import http from "./config/http-configs";
import {configJson} from "@/api/config/http-configs";

//1. 增加扩展字段
export const addFormData = (data) => {
    const url = "/manage/apply/form/add"
    return http.post(url, data, configJson)
}


//2.查询扩展字段
export const getFormData = (type) => {
    const url = `/manage/apply/form/info/${type}`
    return http.get(url)
}


export const getBookForm = () => {
    return http.get(`/manage/apply/form/info/BOOK_APPLY`)
}

export const guardApplyAdd = (apply) => {
    const url = '/manage/apply/add'
    return http.post(url, apply, configJson)
}


export const getApproves = (applyId) => {
    return http.get(`/manage/apply/approve/info/${applyId}`)
}

export const getMakeCopies = (applyId) => {
    return http.get(`/manage/apply/copy/info/${applyId}`)
}

export const getTransfers = (applyId) => {
    return http.get(`/manage/apply/transfer/info/${applyId}`)
}

export const getAccompanies = (applyId) => {
    return http.get(`/manage/apply/accompany/info/${applyId}`)
}

export const getApplyListByVisitCode = (visitCode) => {
    return http.get(`/manage/apply/enter/id/${visitCode}`)
}

export const getApplyLisByGateCardNo = (gateCardNo) => {
    const url = `/manage/apply/enter/card/${gateCardNo}`
    return http.get(url)
}
export const getApplyListByPinCode = (pinCode) => {
    return http.get(`/manage/apply/enter/pin/${pinCode}`)
}

export const getApproveList = (data) => {
    const url = '/manage/apply/list'
    return http.post(url, data, configJson)
}
